import Dialog from 'components/Dialog';
import React from 'react';
import {useDispatch} from 'react-redux';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import history from 'redux/history';
import {packId} from 'common/diplomatIdUtil';
import actions from 'features/layout/redux/actions';
import FormikTextField from 'components/inputs/FormikTextField';
import {useTranslation} from 'react-i18next';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {DialogTypes} from 'common/names';
import Formik from 'components/hook-form/Formik';
import {IVFSNode, IVFSNodeDiplomat, VFSNode, VFSNodeDiplomat} from 'types/diplomat/sftp/VFSNode';
import {FormLabel, Grid} from '@mui/material';
import {GridCentered} from 'components/GridCentered';
import {truncatePath} from 'common/stringUtils';
import escapeFile from 'sanitize-filename';
import {enums} from 'types/enums';
import {VFS_PATH} from 'common/constants';

type Props = {
   open?: boolean;
   data?: IVFSNodeDiplomat;
   onClose: () => void;
};

const CreatePhysicalFolderDialog = ({open = true, data, onClose}: Props) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();

   // console.debug('CreatePhysicalFolderDialog', data);
   const path = data?.absolutePath || data?.path || '';

   const {request} = usePostApi<IVFSNodeDiplomat>(api.vfs, {onFailure: onClose});
   const handleSubmit = (values: IVFSNode) => {
      const vfspath = `${path}/${values.name}`;
      request(
         JSON.stringify({
            ...values,
            parentId: data?.id,
            nodeType: enums.vfsType.enum.PHYSICAL,
            nodeName: values.name,
            path: vfspath,
            vfspath, // path + '/' + values.name,
            // // overwrite: true,
            // folderId: data?.id || null,
            // objectType: DiplomatObjectType.enum.SFTP_GROUP,
            // suspended: false,
         }),
         {
            onSuccess: (_data: IVFSNode) => {
               dispatch(actions.loadTreeNav());
               onClose();
               history.push(`${VFS_PATH}${vfspath}`);
            },
         }
      );
   };
   return (
      <Dialog
         maxWidth="sm"
         header={DialogTypes.CreatePhysicalFolderDialog.dialogName}
         open={open}
         close={onClose}
      >
         <Formik
            initialValues={VFSNode.cast({
               name: '',
            })}
            onSubmit={handleSubmit}
         >
            <>
               <Grid container spacing={1}>
                  <GridCentered item>
                     <FormLabel title={path}>{truncatePath(path)}/</FormLabel>
                  </GridCentered>
                  <GridCentered item flexGrow={1}>
                     <FormikTextField
                        autoFocus
                        required
                        label={t('New Folder Name:')}
                        name={'name'}
                        sanitizer={(val) => escapeFile(val)}
                     />
                  </GridCentered>
               </Grid>
               <FormFooterButtons cancel={onClose} />
            </>
         </Formik>
      </Dialog>
   );
};

export default CreatePhysicalFolderDialog;
